"use client";
import type { ILinkProps } from "./Link";
import { Link, BaseLink } from "./Link";
import { captureEvent } from "@/app/_analytics/analytics";
import { EventName } from "@mw/shared/analyticsEventNames";

export function LinkTracked({
  eventName,
  eventProperties,
  children,
  ...props
}: Omit<ILinkProps, "onClick"> & {
  eventName: EventName;
  eventProperties?: Record<string, unknown>;
  children?: React.ReactNode;
}) {
  return (
    <Link {...props} onClick={() => captureEvent(eventName, eventProperties, { transport: "sendBeacon" })}>
      {children}
    </Link>
  );
}

export function BaseLinkTracked({
  eventName,
  eventProperties,
  children,
  ...props
}: Omit<React.ComponentProps<typeof BaseLink>, "onClick"> & {
  eventName: EventName;
  eventProperties?: Record<string, unknown>;
  children?: React.ReactNode;
}) {
  return (
    <BaseLink {...props} onClick={() => captureEvent(eventName, eventProperties, { transport: "sendBeacon" })}>
      {children}
    </BaseLink>
  );
}
